<template>
    <v-card>
        <v-layout>
            <v-flex xs12 v-if="loading" class="notPrinted">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
            <v-flex xs12 v-if="!loading && loadError" class="notPrinted">
                <v-alert outline :value="true" color="error" icon="error">
                    {{loadError}}
                </v-alert>
            </v-flex>
            <v-flex xs12 v-if="!loading && !loadError" class="notPrinted">
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Cost Reporting</h1>
                    </v-flex>
                </v-layout>
                <v-form v-model="searchFormValid">
                    <v-layout wrap>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="stores"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.storeIDs"
                                multiple
                                label="Stores"
                                hint="Stores"
                                clearable
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-autocomplete
                                :items="departments"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.departmentIDs"
                                multiple
                                label="Departments"
                                hint="Departments"
                                clearable
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="filteredCategories"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.categoryIDs"
                                multiple
                                label="Categories"
                                hint="Categories"
                                clearable
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-autocomplete
                                :items="filteredProducts"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.productIDs"
                                multiple
                                label="Products"
                                hint="Products"
                                clearable
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="startDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.minDate"
                                    label="Start Date"
                                    prepend-icon="event"
                                    hint="Start Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.minDate"
                                    @input="startDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="endDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.maxDate"
                                    label="End Date"
                                    prepend-icon="event"
                                    hint="End Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.maxDate"
                                    @input="endDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm5 offset-sm3>
                            <v-btn block color="success" :disabled="!searchFormValid" :loading="loadingGpReports" @click="loadGPReports">Search</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="gpReports"
                            :loading="loadingGpReports"
                            must-sort
                            hide-actions
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID" @click="props.expanded = !props.expanded">
                                    <td>{{props.item.StoreName}}</td>
                                    <td>{{props.item.DepartmentName}}</td>
                                    <td>{{formatCurrency(props.item.TotalCost)}}</td>
                                    <td>
                                        <v-btn
                                            color="info"
                                            block
                                            @click="viewDetailsGPReport(props.item)"
                                        >
                                            View Details
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loadingGpReports" slot="no-data">
                                <v-alert v-if="loadGpReportsError" outline :value="true" color="error" icon="error">
                                    {{loadGpReportsError}}
                                </v-alert>
                                <v-alert v-if="!loadGpReportsError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showViewDetailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="cancelViewDetailsOrder">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Previous Order Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="selectedGPReport.StoreName"
                                            :readonly="true"
                                            label="Store">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="selectedGPReport.DepartmentName"
                                            :readonly="true"
                                            label="Department">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-data-table
                                            :headers="viewDetailsHeaders"
                                            :items="gpReportsByDate"
                                            :loading="loadingGpReportsByDate"
                                            hide-actions
                                            must-sort
                                        >
                                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                            <template slot="items" slot-scope="props">
                                                <tr :data-id="props.item.ID" >
                                                    <td>{{formatDate(props.item.Date)}}</td>
                                                    <td>{{formatCurrency(props.item.Cost)}}</td>
                                                </tr>
                                            </template>
                                            <template slot="footer">
                                                <tr class="body-2">
                                                    <td>Total</td>
                                                    <td>{{formatCurrency(selectedGPReport.TotalCost)}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="!loadingGpReportsByDate" slot="no-data">
                                                <v-alert v-if="loadGpReportsByDateError" outline :value="true" color="error" icon="error">
                                                    {{loadGpReportsByDateError}}
                                                </v-alert>
                                                <v-alert v-if="!loadGpReportsByDateError" outline :value="true" type="info">
                                                    No results found
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>   
                                <v-layout wrap class="dialog-action-buttons notPrinted">
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="cancelViewDetailsOrder">Back</v-btn>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="triggerPrint">Print</v-btn>
                                    </v-flex>
                                </v-layout>                       
                            </v-flex>
                        </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import formatters from "../../helpers/formatters";
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import util from '@/services/util';
import auth from '@/services/auth';
import _ from "underscore";

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            searchFormValid: false,
            search: {
                storeIDs: [],
                startDate: null,
                endDate: null
            },
            rules: validationRules.rules,
            startDatePickerMenu: false,
            endDatePickerMenu: false,
            headers: [
                {
                    text: "Store",
                    value: "StoreName"
                },
                {
                    text: "Department",
                    value: "DepartmentName"
                },
                {
                    text: "Total Cost",
                    value: "TotalCost"
                },
                {
                    text: "", // view button
                    sortable: false
                }
            ],
            selectedGPReport: {},
            showViewDetailsDialog: false,
            viewDetailsHeaders: [
                    {
                        text: "Date",
                        value: "Date"
                    },
                    {
                        text: "Cost",
                        value: "Cost"
                    },
                ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.storeStore.loading
                || this.$store.state.departmentStore.loading
                || this.$store.state.categoryStore.loading
                || this.$store.state.productStore.loading
        },
        loadError() {
            return this.$store.state.storeStore.loadError
                || this.$store.state.departmentStore.loadError
                || this.$store.state.categoryStore.loadError
                || this.$store.state.productStore.loadError;
        },
        loadingGpReports(){
            return this.$store.state.reportStore.gp.loading;
        },
        loadGpReportsError(){
            return this.$store.state.reportStore.gp.loadError;
        },
        loadingGpReportsByDate(){
            return this.$store.state.reportStore.gp.byDate.loading;
        },
        loadGpReportsByDateError(){
            return this.$store.state.reportStore.gp.byDate.loadError;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active).sort(util.sortByName);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active).sort(util.sortByName);
        },
        gpReports(){
            return this.$store.state.reportStore.gp.gpReports;
        },
        gpReportsByDate(){
            return this.$store.state.reportStore.gp.byDate.gpReportsByDate;
        },
        filteredCategories() {
            var categories = this.$store.state.categoryStore.categories.filter(c => c.Active);

            // Check if the user has selected any departments
            if(this.search.departmentIDs == null || this.search.departmentIDs.length == 0){
                // They haven't, allow only categories which are related to departments the user can select
                return categories.filter(
                    c => c.Departments.some(
                        cd => this.departments.some(d => d.ID == cd.DepartmentID)
                    )
                );
            }

            // Allow only categories which are related to departments the user has selected
            return categories.filter(
                c => c.Departments.some(
                    cd => this.search.departmentIDs.some(d => d == cd.DepartmentID)
                )
            );
        },
        filteredProducts() {
            var products = this.$store.state.productStore.products.filter(c => c.Active);

            // Check if the user has selected any categories
            if(this.search.categoryIDs == null || this.search.categoryIDs.length == 0){
                // They haven't, allow only products which are related to categories the user can select
                return products.filter(
                    p => this.filteredCategories.some(c => c.ID == p.CategoryID)
                );
            }

            // Allow only products which are related to categories the user has selected
            return products.filter(
                p => this.search.categoryIDs.some(c => c == p.CategoryID)
            );
        },
        searchCategoryIDs(){
            if(this.search.categoryIDs == null){
                return [];
            }

            let categoryIDs = this.search.categoryIDs.filter(
                cID => this.filteredCategories.some(c => c.ID == cID)
            );

            return categoryIDs;
        },
        searchProductIDs(){
            if(this.search.productIDs == null){
                return [];
            }

            let productIDs = this.search.productIDs.filter(
                pID => this.filteredProducts.some(p => p.ID == pID)
            );

            return productIDs;
        }
    },
    methods: {
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        loadProducts() {
            this.$store.dispatch("productStore/loadProducts");
        },
        allowedDates(val){
            return true;
        },
        clearGPReports(){
            this.$store.dispatch("reportStore/clearGPReports");
        },
        loadGPReports() {
            this.$store.dispatch("reportStore/loadGPReports", {
                params: {
                    SearchMinDate: this.search.minDate,
                    SearchMaxDate: this.search.maxDate,
                    SearchStoreIDs: JSON.stringify(this.search.storeIDs),
                    SearchDepartmentIDs: JSON.stringify(this.search.departmentIDs),
                    SearchCategoryIDs: JSON.stringify(this.searchCategoryIDs),
                    SearchProductIDs: JSON.stringify(this.searchProductIDs)
                }
            });
        },
        formatDate(dateString){
            let date = new Date(dateString);

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            return day + "/" + month + "/" + year;
        },
        formatCurrency(value) {
            if(value == null){
                return;
            }

            return formatters.formatCurrency(value);
        },
        formatPercentage(value){
            if(value == null){
                return;
            }

            return formatters.formatPercentage(value);
        },
        clearGPReportsByDate(){
            this.$store.dispatch("reportStore/clearGPReportsByDate");
        },
        viewDetailsGPReport(item) {
            var that = this;
            this.selectedGPReport = Object.assign({}, item);
            this.clearGPReportsByDate();
            this.$store.dispatch("reportStore/loadGPReportsByDate", {
                params: {
                    SearchMinDate: this.search.minDate,
                    SearchMaxDate: this.search.maxDate,
                    SearchStoreIDs: JSON.stringify([this.selectedGPReport.StoreID]),
                    SearchDepartmentIDs: JSON.stringify([this.selectedGPReport.DepartmentID]),
                    SearchCategoryIDs: JSON.stringify(this.searchCategoryIDs),
                    SearchProductIDs: JSON.stringify(this.searchProductIDs)
                }
            });
            this.showViewDetailsDialog = true;
        },
        cancelViewDetailsOrder() {
            this.showViewDetailsDialog = false;
            this.selectedGPReport = {};
        },
        triggerPrint(){
            window.print();
        }
    },
    created() {
        this.loadStores();
        this.loadCategories();
        this.loadDepartments();
        this.loadProducts();
        this.clearGPReports();
    }
};
</script>

<style>
    
</style>
